import * as React from 'react';
import { Mutation, MutationProps } from 'react-apollo';
import { FirebaseAuthProvider } from '.';

function getRequestContext(
  token: string | null
): Record<string, any> | undefined {
  if (!token) {
    return undefined;
  }
  return {
    headers: {
      authorization: token
    }
  };
}

const AuthorizedMutation = (props: MutationProps) => (
  <FirebaseAuthProvider>
    {(user, token) => (
      <Mutation
        {...props}
        context={getRequestContext(token)}
      />
    )}
  </FirebaseAuthProvider>
);

export default AuthorizedMutation;



// WEBPACK FOOTER //
// ./src/providers/AuthorizedMutation.tsx